export default __webpack_public_path__ + "static/media/silueta-mujer.f53468da.png";